import { IS_BROWSER } from '@/common/constant';

/**
 * Logs system memory
 * @param logger
 * @returns
 */
export async function logSystemMemory(logger: Logger) {
  if (IS_BROWSER) return;
  try {
    const res = process.getSystemMemoryInfo();
    const { free, total } = res;
    const usage = ((total - free) / total) * 100;
    const log = [`total: ${total / 1024 / 1024}`, `free: ${free / 1024 / 1024}`, `usage: ${usage.toFixed(2)}`];
    logger.info('[process] sys ', log.join(' , '));
  } catch (error) {}
}

/**
 * Logs process memory
 * @param logger
 * @returns
 */
export async function logProcessMemory(logger: Logger) {
  if (IS_BROWSER) return;
  try {
    const res = await process.getProcessMemoryInfo();
    const log = [
      `residentSet: ${res.residentSet / 1024}`,
      `private: ${res.private / 1024}`,
      `shared: ${res.shared / 1024}`,
    ];
    logger.info('[process] pro', log.join(' , '));
  } catch (error) {}
}

export function logMemory(logger: Logger) {
  if (IS_BROWSER) return;
  logSystemMemory(logger);
  logProcessMemory(logger);
}
